import { render } from "./SmsStepTwo.vue?vue&type=template&id=3c339340&scoped=true"
import script from "./SmsStepTwo.vue?vue&type=script&lang=js"
export * from "./SmsStepTwo.vue?vue&type=script&lang=js"

import "./SmsStepTwo.vue?vue&type=style&index=0&id=3c339340&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-3c339340"

export default script